module.exports = __webpack_public_path__ + "img/permission-tech_new.c331ccc7.png";